import { Brand } from '../brand/brand.model';
import { Channel } from '../channel/channel.model';
import { Dealer } from '../dealer/dealer.model';

export class LeadImportInput {
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  vat?: string;
  descriptionModel?: string;
  type?: string;
  brand?: Brand;
  channel?: Channel;
  dealer?: Dealer;
  comments?: string;
  origin?: string;
  postalCode: string;
  location: string;
  address?: string;
  scoring?: number;
  status?: string;
  createdAt?: string;
  onTrackDate?: string;
  temp?: string;
  closeDate?: string;
  archivedDate?: string;
  user?: string;
  offerId?: string;
  archivedType?: string;
  archivedComment?: string;
  closeComment?: string;
  onTrackComment?: string;
  plate?: string;
}
